/**
 * The edit — mobile "next image" arrow.
 *
 * The gallery is a native horizontal scroller (overflow-x with
 * scroll-behavior: smooth), so advancing it needs no carousel library: setting
 * scrollLeft is enough and the smooth behaviour comes from CSS.
 *
 * Delegated from the document so it survives section re-renders in the theme
 * editor, where this markup is replaced wholesale on every setting change.
 */
(function () {
  /**
   * How far one tap should travel: the width of an item plus the gap between
   * items, measured from the DOM rather than hard-coded, since the item width
   * is set in CSS and changes with the breakpoint.
   *
   * @param {HTMLElement} track
   * @returns {number}
   */
  function stepFor(track) {
    const first = track.querySelector('.the-edit__item');
    if (!first) return track.clientWidth;

    const second = first.nextElementSibling;
    if (second) {
      const delta = second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      if (delta > 0) return delta;
    }

    return first.getBoundingClientRect().width || track.clientWidth;
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-the-edit-next]');
    if (!button) return;

    const section = button.closest('.the-edit');
    const track = section && section.querySelector('[data-the-edit-track]');
    if (!track) return;

    const step = stepFor(track);
    const max = track.scrollWidth - track.clientWidth;

    // Wrap back to the start once there is nothing further right, so the arrow
    // never becomes a dead control at the end of the gallery.
    const next = track.scrollLeft + step;
    track.scrollLeft = next > max - 1 ? 0 : next;
  });
})();
